'use strict';

fbDateTimePicker.$inject = ["gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbDateTimePicker = fbDateTimePicker;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _datetimepicker = require('./datetimepicker.controller');

var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

var _dateTimeHelper = require('./dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

require('moment');

require('eonasdan-bootstrap-datetimepicker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fbDateTimePicker(gettextCatalog) {
    'ngInject';

    return {
        restrict: 'A',
        controller: _datetimepicker2.default,
        controllerAs: 'vmDatetimepicker',
        link: function link(scope, element, attribute) {

            var format = _dateTimeHelper2.default.getMomentFormat(attribute.format || _dateTimeHelper2.default.defaultDateTimeFormat);
            // Check if it is used as an attribute.
            // Added in case we want to extend to element usage

            if (attribute.$attr.fbDateTimePicker) {
                _angular2.default.element(element).datetimepicker({
                    format: format,
                    locale: window.localStorage.getItem('language'),
                    icons: {
                        time: 'ico ico-time',
                        date: 'ico ico-calendar',
                        up: 'ico ico-angle-up',
                        down: 'ico ico-angle-down',
                        previous: 'ico ico-angle-left',
                        next: 'ico ico-angle-right',
                        today: 'ico ico-target',
                        clear: 'ico ico-delete',
                        close: 'ico ico-close'
                    },
                    tooltips: {
                        today: gettextCatalog.getString('Go to today', null, 'Datetimepicker tooltips'),
                        clear: gettextCatalog.getString('Clear selection', null, 'Datetimepicker tooltips'),
                        close: gettextCatalog.getString('Close the picker', null, 'Datetimepicker tooltips'),
                        selectMonth: gettextCatalog.getString('Select Month', null, 'Datetimepicker tooltips'),
                        prevMonth: gettextCatalog.getString('Previous Month', null, 'Datetimepicker tooltips'),
                        nextMonth: gettextCatalog.getString('Next Month', null, 'Datetimepicker tooltips'),
                        selectYear: gettextCatalog.getString('Select Year', null, 'Datetimepicker tooltips'),
                        prevYear: gettextCatalog.getString('Previous Year', null, 'Datetimepicker tooltips'),
                        nextYear: gettextCatalog.getString('Next Year', null, 'Datetimepicker tooltips'),
                        selectDecade: gettextCatalog.getString('Select Decade', null, 'Datetimepicker tooltips'),
                        prevDecade: gettextCatalog.getString('Previous Decade', null, 'Datetimepicker tooltips'),
                        nextDecade: gettextCatalog.getString('Next Decade', null, 'Datetimepicker tooltips'),
                        prevCentury: gettextCatalog.getString('Previous Century', null, 'Datetimepicker tooltips'),
                        nextCentury: gettextCatalog.getString('Next Century', null, 'Datetimepicker tooltips'),
                        incrementHour: gettextCatalog.getString('Increment Hour', null, 'Datetimepicker tooltips'),
                        pickHour: gettextCatalog.getString('Pick Hour', null, 'Datetimepicker tooltips'),
                        decrementHour: gettextCatalog.getString('Decrement Hour', null, 'Datetimepicker tooltips'),
                        incrementMinute: gettextCatalog.getString('Increment Minute', null, 'Datetimepicker tooltips'),
                        pickMinute: gettextCatalog.getString('Pick Minute', null, 'Datetimepicker tooltips'),
                        decrementMinute: gettextCatalog.getString('Decrement Minute', null, 'Datetimepicker tooltips'),
                        incrementSecond: gettextCatalog.getString('Increment Second', null, 'Datetimepicker tooltips'),
                        pickSecond: gettextCatalog.getString('Pick Second', null, 'Datetimepicker tooltips'),
                        decrementSecond: gettextCatalog.getString('Decrement Second', null, 'Datetimepicker tooltips')
                    }
                });
                // Angular magic =-)

                // Cleanup tooltip
                element.on('$destroy', function () {
                    if (_angular2.default.element(element).data('DateTimePicker')) {
                        _angular2.default.element(element).data('DateTimePicker').destroy();
                    }
                });
            }
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/datepicker/datetimepicker.directive.js
// module id = 709
// module chunks = 0